import { svg } from "lit";
const icon = svg `<path d="M3.41675 14.1957V13.1124H16.5834V14.1957H3.41675ZM3.41675 10.5418V9.45854H16.5834V10.5418H3.41675ZM3.41675 6.888V5.80469H16.5834V6.888H3.41675Z" fill="currentColor"/>`;
export default icon;
